module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-breadcrumbs">\r\n	<ul class="b-breadcrumbs__items js-items-container"></ul>\r\n</div>\r\n<div class="b-breadcrumbs__mobile-arrows desktop-hide"></div>\r\n';

}
return __p
}